import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { addNotification } from '../../../.././../actions/notifications';
import Toggle from '../../../.././../components/light-weight/Toggle';
import { getSignalsList } from '../../../../../stores/signals-main/signals/getters';
import { toggleSignal } from '../../../../../stores/signals-main/signals/actions';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .progress': {
      marginLeft: 10,
      display: 'flex',
      '& .MuiCircularProgress-indeterminate': {
        animationDuration: '0.65s',
      },
    },
  },
}));

const CellEnabled = ({ row = {} }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;

  const enabled = useSelector((state) => {
    const signals = getSignalsList(state) || [];

    const { enabled = false } = signals.find((d) => d._id === _id) || {};

    return enabled;
  });

  const enabledLoading = useSelector((state) => {
    const signals = getSignalsList(state) || [];

    const { enabledLoading = false } = signals.find((d) => d._id === _id) || {};

    return enabledLoading;
  });

  const handleToggle = async () => {
    try {
      const targetState = !enabled;

      const { isSuccess = false } = await dispatch(
        toggleSignal(_id, targetState)
      );

      if (isSuccess) {
        dispatch(
          addNotification({
            type: 'success',
            message: `Signal ${
              targetState ? 'enabled' : 'disabled'
            } successfully`,
          })
        );
      }
    } catch (err) {
      if (err && err.message && err.message === 'Network Error') {
        dispatch(
          addNotification({
            type: 'error',
            message: 'Signal toggle failed',
          })
        );
      }
    }
  };

  return (
    <div className={classes.root}>
      {enabledLoading ? (
        <div className="progress">
          <CircularProgress disableShrink size={22} thickness={5} />
        </div>
      ) : (
        <Toggle checked={enabled} onChange={handleToggle} />
      )}
    </div>
  );
};

export default CellEnabled;
